/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type ListTeamsAuthTeamsResponse429ResponseBodyData = {
  message: string;
};

/**
 * Rate limited
 */
export class ListTeamsAuthTeamsResponse429ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: ListTeamsAuthTeamsResponse429ResponseBodyData;

  constructor(
    err: ListTeamsAuthTeamsResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListTeamsAuthTeamsResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type ListTeamsAuthTeamsResponse409ResponseBodyData = {
  message: string;
};

/**
 * Conflict
 */
export class ListTeamsAuthTeamsResponse409ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: ListTeamsAuthTeamsResponse409ResponseBodyData;

  constructor(
    err: ListTeamsAuthTeamsResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListTeamsAuthTeamsResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type ListTeamsAuthTeamsResponse404ResponseBodyData = {
  message: string;
};

/**
 * Not found
 */
export class ListTeamsAuthTeamsResponse404ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: ListTeamsAuthTeamsResponse404ResponseBodyData;

  constructor(
    err: ListTeamsAuthTeamsResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListTeamsAuthTeamsResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type ListTeamsAuthTeamsResponseResponseBodyData = {
  message: string;
};

/**
 * Forbidden
 */
export class ListTeamsAuthTeamsResponseResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: ListTeamsAuthTeamsResponseResponseBodyData;

  constructor(
    err: ListTeamsAuthTeamsResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListTeamsAuthTeamsResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type ListTeamsAuthTeamsResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class ListTeamsAuthTeamsResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: ListTeamsAuthTeamsResponseBodyData;

  constructor(
    err: ListTeamsAuthTeamsResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListTeamsAuthTeamsResponseBody";
  }
}

/**
 * Bad request
 */
export type ListTeamsResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class ListTeamsResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: ListTeamsResponseBodyData;

  constructor(
    err: ListTeamsResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListTeamsResponseBody";
  }
}

/** @internal */
export const ListTeamsAuthTeamsResponse429ResponseBody$inboundSchema: z.ZodType<
  ListTeamsAuthTeamsResponse429ResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new ListTeamsAuthTeamsResponse429ResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type ListTeamsAuthTeamsResponse429ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListTeamsAuthTeamsResponse429ResponseBody$outboundSchema:
  z.ZodType<
    ListTeamsAuthTeamsResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    ListTeamsAuthTeamsResponse429ResponseBody
  > = z.instanceof(ListTeamsAuthTeamsResponse429ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ListTeamsAuthTeamsResponse409ResponseBody$inboundSchema: z.ZodType<
  ListTeamsAuthTeamsResponse409ResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new ListTeamsAuthTeamsResponse409ResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type ListTeamsAuthTeamsResponse409ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListTeamsAuthTeamsResponse409ResponseBody$outboundSchema:
  z.ZodType<
    ListTeamsAuthTeamsResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    ListTeamsAuthTeamsResponse409ResponseBody
  > = z.instanceof(ListTeamsAuthTeamsResponse409ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ListTeamsAuthTeamsResponse404ResponseBody$inboundSchema: z.ZodType<
  ListTeamsAuthTeamsResponse404ResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new ListTeamsAuthTeamsResponse404ResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type ListTeamsAuthTeamsResponse404ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListTeamsAuthTeamsResponse404ResponseBody$outboundSchema:
  z.ZodType<
    ListTeamsAuthTeamsResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    ListTeamsAuthTeamsResponse404ResponseBody
  > = z.instanceof(ListTeamsAuthTeamsResponse404ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ListTeamsAuthTeamsResponseResponseBody$inboundSchema: z.ZodType<
  ListTeamsAuthTeamsResponseResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new ListTeamsAuthTeamsResponseResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type ListTeamsAuthTeamsResponseResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListTeamsAuthTeamsResponseResponseBody$outboundSchema: z.ZodType<
  ListTeamsAuthTeamsResponseResponseBody$Outbound,
  z.ZodTypeDef,
  ListTeamsAuthTeamsResponseResponseBody
> = z.instanceof(ListTeamsAuthTeamsResponseResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));

/** @internal */
export const ListTeamsAuthTeamsResponseBody$inboundSchema: z.ZodType<
  ListTeamsAuthTeamsResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new ListTeamsAuthTeamsResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type ListTeamsAuthTeamsResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListTeamsAuthTeamsResponseBody$outboundSchema: z.ZodType<
  ListTeamsAuthTeamsResponseBody$Outbound,
  z.ZodTypeDef,
  ListTeamsAuthTeamsResponseBody
> = z.instanceof(ListTeamsAuthTeamsResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));

/** @internal */
export const ListTeamsResponseBody$inboundSchema: z.ZodType<
  ListTeamsResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new ListTeamsResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type ListTeamsResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListTeamsResponseBody$outboundSchema: z.ZodType<
  ListTeamsResponseBody$Outbound,
  z.ZodTypeDef,
  ListTeamsResponseBody
> = z.instanceof(ListTeamsResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
